export default __webpack_public_path__ + "static/media/cards.6c207e84.svg";